// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';
// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
// import { stylePremium } from './utils/helpers';
// import config from './config';
// import cases from './graphic';
// import { select, selectAll } from 'd3-selection';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

const dayjs = require('dayjs');
const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);
const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;

  pymChild.sendHeight();
  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const trackerCategories = Array.from(document.querySelectorAll('section.category'));

trackerCategories[0].classList.add('active');


const selectCase = (event) => {
  const categId = event.target.dataset.slug;
  showCateg(categId);
};


const getData = async () => {
  const url = 'https://ix.cnn.io/data/2026-olympics/medal-list.json';
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    return json;
  } catch (error) {
    console.error(error.message);
  }
};

const template = obj => `<div class="row">
            <div class="ranking">${obj.medals.rank}</div>
            <div class="country-wrapper">
              <div class="country-name">
                <img class="flag" src="${obj.country.flag}" alt="${obj.country.name}" />
                <span class="desktop">${obj.country.name}</span>
                <span class="mobile">${obj.country.code}</span>
              </div>
              <div class="medals">
                <div class="gold">${obj.medals.gold}</div> <div class="silver">${obj.medals.silver}</div> <div class="bronze">${obj.medals.bronze}</div>
                <div class="total"><span>Total </span><span>${obj.medals.total}</span></div>
              </div>
            </div>
          </div>`;


const medalsListContainer = document.getElementById('cnnv-rows');
const timestampContainer = document.getElementById('cnnv-timestamp');

const init = async () => {
  const data = await getData();
  console.log(data);

  const { countries } = data.modules.medalSlot.medalsList;
  const timestampTxt = new Date(data.header.lastUpdate);
  console.log(timestampTxt);
  timestampContainer.innerHTML = dayjs.utc(timestampTxt).format('H:mm [GMT]');
  let countryListHtml = '';
  // Check to see if there are medals, if not show a message
  if (countries.length === 0) {
    countryListHtml = '<div class="row"><div class="country-wrapper"><div class="country-name inactive">No medals have been awarded yet</div></div></div>';
  } else {
    countries.map((obj, idx) => (idx < 5 ? countryListHtml += template(obj) : null));
  }
  medalsListContainer.innerHTML = countryListHtml;
};

init();
